export const navigateToCase = (caseID) => {
  const url = `${window.location.origin}/Presentation/Page/PMS/CasePage.aspx?Case=`;
  window.open(url + caseID, '_blank');
};